<div *ngIf="isBoxLoaderShown" class="box-loader-wrapper d-flex justify-content-center align-items-center">
    <div class="box-loader-container text-center">
        <div class="loader">
            <ng-lottie width="200px" height="200px" [options]="loaderOptions"></ng-lottie>
        </div>
        <div class="loader-info">{{ 'payment.status_description' | translate }}</div>
    </div>
</div>
